"use strict";
/*
 * Module for keeping track of output queue or buffer state, i.e. whether it
 * underuns or overruns. Driven by 'ticks' which inform the object about state
 * (corresponding to audio callbacks which cause queue/buffer to be written to),
 * it triggers actions on state change: debug log and sending report to a message port.
 *
 * The rationale is that under- and overruns typically come in batches over many
 * consecutive ticks and it usually makes sense to log/report them together.
 */
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _condition, _tickCount, _report, _debug;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrunReporter = exports.UnderrunReporter = void 0;
class ConditionReporter {
    constructor(report, debug) {
        _condition.set(this, false);
        _tickCount.set(this, 0); // number of ticks in the condition
        _report.set(this, void 0);
        _debug.set(this, void 0);
        __classPrivateFieldSet(this, _report, report);
        __classPrivateFieldSet(this, _debug, debug);
    }
    tick(condition) {
        if (!__classPrivateFieldGet(this, _condition) && condition) {
            const name = this.name();
            __classPrivateFieldGet(this, _debug).call(this, `Start output buffer ${name}`);
            __classPrivateFieldGet(this, _report).call(this, { type: 'output-buffer-condition', condition: name, event: 'start' });
            __classPrivateFieldSet(this, _condition, true);
            __classPrivateFieldSet(this, _tickCount, 1);
        }
        else if (__classPrivateFieldGet(this, _condition) && !condition) {
            const name = this.name();
            __classPrivateFieldGet(this, _debug).call(this, `End output buffer ${name}, lasted ${__classPrivateFieldGet(this, _tickCount)} ticks`);
            __classPrivateFieldGet(this, _report).call(this, { type: 'output-buffer-condition', condition: name, event: 'end', count: __classPrivateFieldGet(this, _tickCount) });
            __classPrivateFieldSet(this, _tickCount, 0);
            __classPrivateFieldSet(this, _condition, false);
        }
        else if (condition) {
            __classPrivateFieldSet(this, _tickCount, +__classPrivateFieldGet(this, _tickCount) + 1);
        }
    }
}
_condition = new WeakMap(), _tickCount = new WeakMap(), _report = new WeakMap(), _debug = new WeakMap();
class UnderrunReporter extends ConditionReporter {
    constructor(report, debug) {
        super(report, debug);
    }
    name() {
        return 'underrun';
    }
}
exports.UnderrunReporter = UnderrunReporter;
class OverrunReporter extends ConditionReporter {
    constructor(report, debug) {
        super(report, debug);
    }
    name() {
        return 'overrun';
    }
}
exports.OverrunReporter = OverrunReporter;
